import { useCallback, useEffect, useState } from "react";
import { useIdentity } from "../../../hooks";
import { oauth } from "../../../utils";

interface QboCustomer {
  Id: string;
  DisplayName: string;
}

interface XeroContact {
  ContactID: string;
  Name: string;
}

export function useAccountingCustomers() {
  const identity = useIdentity();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [customers, setCustomers] = useState([]);

  const loadCustomers = useCallback(
    async () => {
      try {
        setLoading(true);
        if ("QBO" === identity.accounting_software) {
          const response = await oauth("POST", "quickbooks", {
            action: "get_entity",
            entity_name: "Customer"
          });
          if (!response.json) {
            setError("Unable to get customers");
            return;
          }
          setCustomers(
            Object.values(response.json.customers).map(
              (customer: QboCustomer) => ({
                id: `${customer.Id}`,
                name: customer.DisplayName,
              })
            )
          );
        } else if ("XERO" === identity.accounting_software) {
          const response = await oauth("POST", "xero", {
            action: "get_contacts",
          });
          if (!response.json) {
            setError("Unable to get customers");
            return;
          }
          setCustomers(
            Object.values(response.json.contacts).map(
              (contact: XeroContact) => ({
                id: `${contact.ContactID}`,
                name: contact.Name,
              })
            )
          );
        }
      } catch (error) {
        setError(error.toString());
      } finally {
        setLoading(false);
      }
    },
    [identity.accounting_software]
  );

  useEffect(
    () => {
      loadCustomers();
    },
    [loadCustomers]
  );

  return {
    loading,
    error,
    customers,
    loadCustomers
  };
}
